<template>
    <div style="padding-bottom: 100px;">
        <div v-for="(item,index) in matchInfo" :key="item.id" v-show="isshow"  :class="['mainuser', item.sex == '男' ? 'man' : 'girl' ]">
            <div  class="box" >
                <div class="user">
                    <div class="title">{{item.name}}</div>
                    <div class="phone">{{item.mobile}}</div>
                </div>
                <div>
                    <Checkbox v-model="checked[item.name]" @click="onChange(item,index)" checked-color="#ff8c5f"></Checkbox>
                </div>
            </div>
        </div>
        <div class="footer apppadding button">
            <div class="btn">
                <Button plain type="warning" @click="updateUse" size="large" round style="font-size: 30px;" >+</Button>
            </div>
            <div class="btn">
                <Button type="warning" @click="signUp" size="large" :disabled="disabled" round >确认</Button>
            </div>         
        </div>
    </div>
</template>

<script>
  import './userlist.less'
  import {mymemberlist} from '@/libs/api'
  import {Button, Checkbox} from 'vant';
  import {setStorage, getStorage} from '@/libs/utils'

  export default {
    name: 'userlist',
    components: {
        Button,
        Checkbox
    },
    data() {
        return {
            matchInfo: [],
            checked: {},
            isshow: false,
            disabled: true,
            info: null,
            num: 0,
            params: {},
            urid: '',
            token: ''
        }
    },
    methods:{
      onChange(e,index){    
          this.info = e
          this.num = index
          this.disabled = false 
          this.signUp()
      },
      updateUse(){
          var postparams = {}
          postparams = this.params
          if(postparams.groupcode){
              delete postparams.fromrole
          }else{
              postparams.fromrole = 1
          }
          this.$router.replace({name:'adduser',params:postparams});
      },
      signUp(){
          var postparams = {}
          postparams = this.params
          if(postparams.groupcode){
          delete postparams.fromrole
          postparams.index = this.num
          }else{
          postparams.fromrole = 1
          }
          postparams.info = this.info
          postparams.formrule = this.params.form
          if(postparams.form){
          delete postparams.form
          }
          this.$router.replace({name:'adduser',params:postparams})
      },
      memberlist(){
          mymemberlist({urid:this.urid,token:this.token}).then((res) => {
              if (res.status == 200) {
                  if(res.data.list.length == 0){
                      this.matchInfo = []
                      this.isshow = false
                  }else{
                      res.data.list.forEach((item) => {
                          item.attrs  =   JSON.parse(item.memberinfos);
                          item.attrs.forEach((citem) => {
                              if (citem.key_name == 'mv_name') {
                                  item.name = citem.value;
                              }
                              if (citem.key_name == 'mv_mobile') {
                                  item.mobile = citem.value;
                              }
                              if (citem.key_name == 'mv_sex') {
                                  item.sex = citem.value;
                              }

                          })

                          item.attrs = JSON.stringify(item.attrs);
                      })
                      this.matchInfo = res.data.list
                      this.isshow = true
                  }
              }
          })
      }
    },
    mounted() {
        this.$nextTick(() => {
            let userinfo = getStorage('userInfo')
            this.urid = userinfo.urid
            this.token = userinfo.token
            let param = this.$route.params
            let arr = Object.keys(param);
            if(arr.length == 0){
                this.params = getStorage('userlist')
            }else{
                this.params = this.$route.params
                setStorage('userlist',this.params,true)
            }
            this.memberlist()

        })
    }

  }
</script>